import './InnerTabs.css'

/**
 * Filele DINAUNTRUL unui ecran de setari - al treilea nivel de meniu, sub bara
 * `od-tabbar` a ecranului. Perechea veche: `ul.nav.nav-tabs.tabs-shdw`.
 *
 * Arata ca bara de deasupra lor, nu ca in `od_console.css`. Acolo `nav-tabs`
 * primeste `padding: 8px 0` si tot spatiul in `margin-right: 18px`: cuvinte
 * goale cu o linie sub cel ales, fara niciun loc de apasat in jurul lor. Bara
 * are `padding: 10px 14px`. Regulile sunt in `InnerTabs.css`, pe clasa
 * `od-inner-tabs` - aceeasi clasa o poarta si o bara de file facuta din
 * butoane (Cost Reports), ca sa nu fie doua feluri de file pe acelasi ecran.
 *
 * FARA `m-0` PE LEGATURI (26.9.15.47): `.m-0` e `margin: 0 !important` si
 * lipea cuvintele unul de altul. Proba: CompanySettingsPage.test.tsx.
 */
export const INNER_TABS_CLASS = 'od-inner-tabs'

export function InnerTabs({
  tabs,
  current,
  onPick,
  className,
}: {
  tabs: { id: string; label: string }[]
  current: string
  onPick(id: string): void
  /** Clasele vechi ale listei, pastrate langa `nav nav-tabs tabs-shdw` (de pilda `userTabs`). */
  className?: string
}) {
  return (
    <ul className={['nav nav-tabs', className, 'tabs-shdw', INNER_TABS_CLASS].filter(Boolean).join(' ')}>
      {tabs.map((tab) => (
        <li key={tab.id} className={tab.id === current ? 'active' : ''}>
          <a
            href={'#' + tab.id}
            aria-expanded={tab.id === current}
            onClick={(event) => {
              event.preventDefault()
              onPick(tab.id)
            }}
          >
            {tab.label}
          </a>
        </li>
      ))}
    </ul>
  )
}
